import { FC } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import Http from '@rootCommon/services/http';
import { dynamicImport, ProtectedRoute, history } from '@rootCommon/utilities';

import store, { persistor } from './store';
import { requestInterceptor } from './interceptors/request';

import './App.scss';

Http.setInterceptorRequest(requestInterceptor);

const Auth = dynamicImport(() => import('./modules/auth'));
const Main = dynamicImport(() => import('./modules/main'));

const App: FC = (): JSX.Element => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <div className="App">
        <Router history={history}>
          <Switch>
            <Route path="/auth" component={Auth} />
            <ProtectedRoute path="/" component={Main} />
          </Switch>
        </Router>
      </div>
    </PersistGate>
  </Provider>
);

export default App;
